module.exports = __webpack_public_path__ + "img/041.1b5608ab.jpeg";